import { createAction, props } from '@ngrx/store';

export const getCurrentUser = createAction('[CurrentUser] Get');
export const storeCurrentUser = createAction('[CurrentUser] Store', props<{ currentUser: any }>());
